import { Images } from '../../helpers/ApiClient';
import { LearnRecapState } from '../reducers/learnRecap';
import type { WorkspaceTemplate } from '../reducers/notes';
import {
  IPreFetchedRequest,
  PrefetchedData,
  PreFetchedDataState,
} from '../reducers/preFetchedData';

export const BOOT = 'boot/BOOT';
export const BOOT_SUCCEEDED = 'boot/BOOT_SUCCEEDED';
export const BOOT_FAILED = 'boot/BOOT_FAILED';

export type Location = {
  params: Record<string, string>;
  pathname: string;
  url: string;
};

export type IBootAction = {
  chapterRef: string | number | null;
  courseRef: string | number;
  isPreview: boolean;
  language: string;
  originalLocation: Location;
  preFetchedData: PreFetchedDataState;
  queryParams: Record<string, string>;
  type: typeof BOOT;
};
export const boot = ({
  chapterRef = null,
  courseRef,
  isPreview,
  language,
  originalLocation,
  preFetchedData,
  queryParams,
}: Omit<IBootAction, 'type'>): IBootAction => ({
  type: BOOT,
  courseRef,
  chapterRef,
  isPreview,
  queryParams,
  language,
  originalLocation,
  preFetchedData,
});

type Entities = {
  chapterProgress?: Record<string, unknown>;
  course: Record<string, unknown>;
  courseProgress?: Record<string, unknown>;
  exercises: Array<Record<string, unknown>>;
  images: Images;
  streakInfo?: {
    daily_xp: number;
    streak: {
      created_at?: string;
      days: number;
      last_incremented_at?: string;
    };
    streak_deadline: string;
  };
  user?: Record<string, unknown>;
  workspaceTemplate: WorkspaceTemplate | null;
};

export type IBootSucceedAction = {
  canonical: boolean;
  chapterId: number;
  courseId: number;
  entities: Entities;
  exerciseNumber: number;
  language: string;
  learnRecap: LearnRecapState;
  pathname: string;
  preFetchedData: Record<string, IPreFetchedRequest>;
  queryParams: Record<string, string>;
  type: typeof BOOT_SUCCEEDED;
};
export const bootSucceeded = ({
  canonical,
  chapterId,
  courseId,
  entities,
  exerciseNumber,
  language,
  learnRecap,
  pathname,
  preFetchedData,
  queryParams,
}: Omit<IBootSucceedAction, 'type'>): IBootSucceedAction => ({
  type: BOOT_SUCCEEDED,
  courseId,
  chapterId,
  exerciseNumber,
  entities,
  pathname,
  queryParams,
  language,
  learnRecap,
  canonical,
  preFetchedData,
});

export const succeedBoot = (args: Omit<IBootSucceedAction, 'type'>) => async (
  dispatch: any,
) => {
  await dispatch(bootSucceeded(args));
};

export type IBootFailedAction = {
  error: string;
  originalError: Error | null;
  preFetchedData: PrefetchedData;
  type: typeof BOOT_FAILED;
};
export const bootFailed = ({
  error,
  originalError,
  preFetchedData,
}: Omit<IBootFailedAction, 'type'>): IBootFailedAction => ({
  type: BOOT_FAILED,
  error,
  originalError,
  preFetchedData,
});

export type BootActions = IBootAction | IBootSucceedAction | IBootFailedAction;
